import { Form, InputGroup } from "react-bootstrap";
import { FormControl, FormErrorMessage, FormLabel, InputGroupControl, Required } from "./Components";
import { ErrorMessage, Field } from "formik";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';

export default function PasswordInput({label, formik, isRequired, theme, ...props}){
    const { name } = props;
    const {touched, errors} = formik;
    const [isClearPassword, setIsClearPassword] = useState(false);
    const handlePaste = (e) => {
        e.preventDefault();
    };
    return (
        <Form.Group className="mb-3">
            {label && <FormLabel>{label} {isRequired && <Required>*</Required>}</FormLabel>}
            <Field name={name}>
              {({ field }) => (
                <InputGroup dir="ltr">
                    <FormControl
                      {...props} className={"ltr"+" "+(theme?"input-"+theme:"")}
                      isInvalid={touched[name] && errors[name]}
                      {...field}
                      type={isClearPassword?"text":"password"}
                      onPaste={handlePaste}
                    />
                    <InputGroupControl className={(theme?"input-"+theme:"")} onClick={(e) => setIsClearPassword(!isClearPassword)}><FontAwesomeIcon icon={isClearPassword?faEyeSlash:faEye} /></InputGroupControl>
                </InputGroup>
                
              )}
            </Field>
            {touched[name] && errors[name] && <ErrorMessage name={name}>
                {(msg) => <FormErrorMessage type="invalid">{msg}</FormErrorMessage>}
            </ErrorMessage>}
        </Form.Group>
    )
}